module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Article-w540.f8475987.webp";